<nb-card>
  <nb-card-header class="d-flex pb-0 pe-3"><morva-icons icon="error"></morva-icons><span class="text me-1">خطا</span></nb-card-header>
  <nb-card-body>
    <p class="text">حساب کاربری شما غیرفعال شده‌است. برای اطلاعات بیشتر با پشتیبانی ارتباط بگیرید.</p>
    <p class="text" *ngIf="supporterContactInfo.contactInfoType === 'Email'">راه ارتباطی با پشتیبانی: {{supporterContactInfo.email}}</p>
    <p class="text" *ngIf="supporterContactInfo.contactInfoType === 'PhoneNumber'">راه ارتباطی با پشتیبانی: {{supporterContactInfo.phoneNumber}}</p>    <div class="d-flex align-items-center justify-content-center"><button tabindex="-1" (click)="close()">تایید</button></div>
  </nb-card-body>
</nb-card>
